import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { LICENSING_ISSUE_TYPE, type LicensingIssue } from '../../../../../shared/issuesV2';
import { useCreateLicenseDispute } from '../../../../hooks/api/issues/useCreateLicenseDispute';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import { getErrorMessage } from '../../../../ReactQuery/errors';
import ModalReportLicenseDispute from '../../../modals/ModalReportLicenseDispute';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';
import type { LicenseDisputeReasonsType } from '../../../../../shared/model-typings/licensedisputes';

import styles from '../DisputeFooter.module.less';

const LicenseIssueDisputeFooter: VoidFunctionComponent = () => {
  const issueDetails = useSelector(IssuesV2Store.selectors.getIssueDetails) as LicensingIssue;
  const { licenseDisputeModal, isAnyModalOpen } = useIssueDetailsModals();

  const { mutateAsync, isPending, error } = useCreateLicenseDispute();

  const onSubmit = async (comment: string, reason: LicenseDisputeReasonsType) => {
    try {
      await mutateAsync({ issueId: issueDetails.id, comment, reason });
      licenseDisputeModal.onClose();
    } catch {
      // The error is shown in the modal from the mutation state.
    }
  };

  const isLicenseConclusion =
    issueDetails?.type === LICENSING_ISSUE_TYPE.UnconcludedDependency ||
    issueDetails?.type === LICENSING_ISSUE_TYPE.MultiLicenseConcluded;

  const btnLabel = isLicenseConclusion
    ? 'Report an issue with this License Conclusion'
    : 'Report a data issue with this license.';

  return (
    <>
      <footer className={styles.footer}>
        Found a mistake?
        {' '}
        <button
          type="button"
          className={styles.footerButton}
          onClick={() => !isAnyModalOpen && licenseDisputeModal.onOpen()}
          disabled={isAnyModalOpen}
        >
          {btnLabel}
        </button>
      </footer>
      <ModalReportLicenseDispute
        errors={error ? [getErrorMessage(error, 'An error occurred.')] : []}
        isCreating={isPending}
        onHide={licenseDisputeModal.onClose}
        onSubmit={onSubmit}
        show={licenseDisputeModal.isOpen}
      />
    </>
  );
};

export default LicenseIssueDisputeFooter;
